import { scroller } from 'react-scroll';

export function scrollToTop() {
  window.scrollTo({
    top: 0,
  });
}

export const scrollToAnchor = (id: string) => {
  scroller.scrollTo(id, { smooth: true, duration: 1000 });
};
